<template>
  <div class="component-pre-orders-table">
    <div>
      <vs-table
        ref="table"
        :data="listPreOrders"
        noDataText="Sem dados disponíveis"
        class="table-data-pre-orders-chat"
        search
        style="padding-right: 22px !important;"
        @search="searchFilter"
        @sort="sortFilter"
        :sst="true"
        :id="checkId(this.$route.name)"
      >
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <div class="ajuste-div-add-new-pre-order" v-if="origin === 'chat'">
            <vs-button
              @click="$emit('createPreOrder', {backIsVisible: true})"
              size="small"
              :class="{'button-create-new-ios': isIos, 'button-create-new-android': isAndroid, 'button-create-new': !isIos && !isAndroid}"
            >
              <span style="font-size: 12px;">Criar Novo Orçamento</span>
              <vs-icon icon="add" size="35px" class="ml-5"/>
            </vs-button>
          </div>

          <div>
            <vs-dropdown
                vs-trigger-click
                class="cursor-pointer mr-4"
            >
              <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2">
                    {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                    {{
                      listPreOrders.length - currentPage * itemsPerPage > 0
                        ? currentPage * itemsPerPage
                        : listPreOrders.length
                  }} de {{ queriedItems }}
                </span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="itemsPerPage=4">
                  <span>4</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=15">
                  <span>15</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=20">
                  <span>20</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </div>

        <template slot="thead">
          <vs-th class="text-base" sort-key="orders.id">
            Identificação
          </vs-th>
          <vs-th class="text-base" sort-key="chat_tickets.customers.name">
            Nome
          </vs-th>
          <vs-th class="text-base" sort-key="chat_tickets.customers.phone_number">
            Telefone
          </vs-th> 
          <vs-th class="text-base" sort-key="users.name">
            Usuário
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody  @click="alterCollspan()">
          <vs-tr
              :data="tr"
              :key="tr.id"
              :id="tr.id"
              v-for="(tr, index) in listPreOrders"
              ref="vsTrElement"
          >
            <vs-td :data="tr.id">
              <p class="text-left" style="font-size: 16.5px;">
                Orçamento {{ tr.id }}
              </p>
            </vs-td>

            <vs-td>
              <p class="text-left" style="font-size: 14px;">
                {{ tr.chatTicket.customer.name }}
              </p>
            </vs-td>

            <vs-td>
              <p class="text-left" style="font-size: 14px;">
                {{ parsePhoneNumber(tr.chatTicket.customer.phone_number) || 'Não Informado'}}
              </p>
            </vs-td>

            <vs-td>
              <p class="text-left" style="font-size: 14px;">
                {{ tr.user ? tr.user.name : 'Não informado' }}
              </p>
            </vs-td>

            <vs-td class="ajuste-tamanho-vstd-preorders">
              <div class="order-infos-btn">
                <vs-button size="small" @click.stop="turnIntoOrder(tr)" class="button-text-center">
                  <span v-if="currentRoute === 'chat-attendance'" style="font-size: 12px;">Continuar/Editar</span>
                  <span v-else style="font-size: 12px;">Continuar</span>
                  <vs-icon icon="keyboard_arrow_right" size="35px"/>
                </vs-button>
              </div>
            </vs-td>

            <vs-td>
              <feather-icon
                  v-if="canSee('delete-pre-order')"
                  icon="TrashIcon"
                  svgClasses="w-7 h-7 hover:text-danger stroke-current"
                  class="ml-2"
                  @click="openDeleteModal(tr.id)"
              />
            </vs-td>

            <template class="expand-user" slot="expand">
              <vs-row style="min-height: 13rem;">
                <vs-col vs-lg="9" vs-sm="6" vs-xs="12">
                  
                  <vs-tabs v-model="selectedTab[index]">
                    <vs-tab :disabled="tr.orderProducts[0] ? false : true" label="Produtos" icon="shopping_basket" size="small">
                      <PreOrdersChildrensVue
                          :idPreOrder="tr.id"
                          :isService="false"
                          :services="null"
                      />
                    </vs-tab>

                    <vs-tab :disabled="tr.services[0] ? false : true" label="Serviços" icon="build" size="small">
                      <PreOrdersChildrensVue
                          :idPreOrder="tr.id"
                          :isService="true"
                          :services="tr.services"
                      />
                    </vs-tab>
                  </vs-tabs>

                </vs-col>

                <vs-col vs-lg="3" vs-sm="6" vs-xs="12">
                  <vs-row class="button-rows" v-if="origin === 'chat'">
                    <div class="order-infos-btn fixed-div-bottom" style="bottom: 2rem;">
                      <vs-button size="medium" type="border" @click.stop="sendPreOrderSummaryToCustomer(tr)" style="border-radius: 14px;">
                        <span>Enviar Resumo Pedido</span>
                      </vs-button>
                    </div>
                  </vs-row>
                  <vs-row>
                    <div class="order-infos-div fixed-div-bottom" v-bind:style="bindStyle()"> 
                      <div v-if="tr.is_delivery">
                        <img :src="orderDelivery" alt="Foto do Entregador">
                        <span> Entregador </span>
                      </div>
                      <div v-else-if="showWithdrawal(tr.address)">
                        <vs-icon icon="store" size="40px"/>
                        <span> Retirada </span>
                      </div>

                      <div v-if="getType(tr.payment_data) !== 'none'">
                        <img
                          v-if="getType(tr.payment_data) === 'card'"
                          src="@/assets/images/payment/card.png"
                          alt="Imagem Cartão"
                          class="card-resize"
                        />
                        <img
                          v-else-if="getType(tr.payment_data) === 'pix'"
                          src="@/assets/images/payment/pix.png"
                          alt="Imagem Pix"
                          class="pix-resize"
                        />
                        <img
                          v-else-if="getType(tr.payment_data) === 'cash'"
                          src="@/assets/images/payment/cash.png"
                          alt="Imagem Dinheiro"
                          class="cash-resize"
                        />
                        <span v-if="getType(tr.payment_data) === 'card'" style="border-radius: 0 !important;"> Cartão </span>
                        <span class="mt-2" v-else-if="getType(tr.payment_data) === 'pix'"> Pix </span>
                        <span class="mt-2" v-else-if="getType(tr.payment_data) === 'cash'"> Dinheiro </span>
                      </div>
                      <div v-if="tr.is_delivery">
                        <vs-icon icon="motorcycle" size="medium"/>
                        <span> Entrega </span>
                      </div>
                    </div>
                  </vs-row>
                </vs-col>
              </vs-row>
            </template>
          </vs-tr>
          </tbody>
        </template>
      </vs-table>

      <div class="mt-3 mr-4">
        <vs-pagination
            :total="totalPages"
            v-model="page"
            @change="closeExpand"
            max="7"
        />
      </div>
    </div>

    <vs-popup
      title="Deletar Pré - Pedido:"
      id="popTransformNewProduct"
      :active.sync="openModalToConfirmIsActive"
    >
      <p> Clique em confirmar para fazer a deleção desse Pré - Pedido!
      </p> <br>
      <div class="w-full d-flex justify-content-flex-end">
        <vs-button color="success" @click.stop="deletePreOrder">Confirmar</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import moduleOrder from "@/store/order/moduleOrder";
import Product from '@/http/requests/product';
import httpOrder from "@/http/requests/orders";
import PreOrdersChildrensVue from "@/views/orders/pre-orders/PreOrdersChildrens.vue";
import {hasPermission, maskPhoneNumber} from "@/utils";

export default {
  name: 'pre-orders-table',
  components: {
    PreOrdersChildrensVue
  },
  data() {
    return {
      cService: null,
      customers: [],
      page: 1,
      itemsPerPage: 4,
      search: '',
      orderBy: {
        name: 'orders.id',
        type: 'DESC',
        lastDesc: true
      },
      openModalToConfirmIsActive: false,
      targetToDelete: null,
      isMounted: false,
      currentRoute: this.$route.name,
      selectedTab: []
    }
  },
  props: {
    origin: {
      type: String,
      required: false,
      default: 'chat'
    },
    customerId: {
      type: Number,
      required: false,
      default: null
    },
  },
  emits: [
    'isActiveFalse',
    'turnIntoOrder',
    'createPreOrder'
  ],
  computed: {
    isIos() {
      return window.innerWidth <= 430 && window.innerHeight <= 932;
    },
    isAndroid() {
      return window.innerWidth <= 393 && window.innerHeight <= 873;
    },
    totalPages() {
      return this.$store.state.order && this.$store.state.order.pre_orders.total_pages
          ? this.$store.state.order.pre_orders.total_pages
          : 0
    },
    queriedItems() {
      return this.$store.state.order && this.$store.state.order.pre_orders.total_items
          ? this.$store.state.order.pre_orders.total_items
          : 0
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }

      return 0;
    },
    listPreOrders() {
      return this.$store.state.order ? this.$store.state.order.pre_orders.items : [];
    },
    orderDelivery() {
      return this.$store.state.AppActiveUser.image;
    },
  },
  methods: {
    async dataLoad() {
      if (!moduleOrder.isRegistered) {
        this.$store.registerModule('order', moduleOrder)
        moduleOrder.isRegistered = true
      }
      await this.$store.dispatch("order/fetchAllPreOrders", {
        sortName: this.orderBy.name,
        page: this.page,
        itemsPerPage: this.itemsPerPage,
        type: this.orderBy.type,
        word: this.search,
        customerId : this.customerId
      });
      
    },
    closePopUp() {
      this.$emit('closePopup');
    },
    alterCollspan () {
      const tr = document.querySelectorAll('.tr-expand > td');
      tr.forEach((item) => {
        item.colSpan = 6;
      })
    },
    parsePhoneNumber(number) {
      return maskPhoneNumber(number);
    },
    turnIntoOrder(data) {
      if (typeof data.files === 'string') {
        data.files = JSON.parse(data.files);
      } 
      else {
        data.files = [];
      }
      this.$emit('turnIntoOrder', data);
    },
    sendPreOrderSummaryToCustomer(data) {
      data.postSentMessage = true
      this.$vs.dialog({
        type:'confirm',
        color: 'primary',
        title: `Atenção!`,
        text: 'Ao clicar em "Enviar", um resumo desse Pré-Pedido será disparado para o cliente. ' +
            'Os dados do pedido serão montados em formado de lista e irão por escrito para a caixa ' +
            'de texto dentro do chat, ficando a critério do atendente revisar e editar essa mensagem ' +
            'caso necessário antes do envio!',
        accept: () => {
          this.closePopUp();
          this.$events.fire('sendPreOrderSummaryToCustomer', data);
        },
        acceptText: 'Enviar',
        cancelText: 'Voltar',
      })
    },
    async searchFilter(searchQuery) {
      this.closeExpand();
      this.search = searchQuery;
      await this.dataLoad();
    },
    async sortFilter(sortName) {
      this.closeExpand();
      if (sortName !== null) {
        if (sortName !== this.orderBy.name) {
          this.orderBy.name = sortName;
          this.orderBy.type = 'ASC';
        } else if (this.orderBy.type !== "" && this.orderBy.type === "ASC") {
          this.orderBy.type = 'DESC';
        } else if (this.orderBy.lastDesc && this.orderBy.name === 'orders.id') {
          this.orderBy.type = 'ASC';
          this.orderBy.lastDesc = false;
        } else if (this.orderBy.name === sortName && this.orderBy.type === "DESC") {
          this.orderBy.name = 'orders.id';
          this.orderBy.type = 'DESC';
          if (this.orderBy.name === 'orders.id') {
            this.orderBy.lastDesc = true;
          }
        }
        await this.dataLoad();
      }
    },
    openDeleteModal(id) {
      this.openModalToConfirmIsActive = true;
      this.targetToDelete = id;
    },
    deletePreOrder() {
      this.closeExpand();
      httpOrder.deleteOrder(this.targetToDelete)
        .then((response) => {
          this.$vs.notify({
            color: 'success',
            title: 'Produto deletado com sucesso!'
          });
          this.targetToDelete = null;
          this.openModalToConfirmIsActive = false;
          this.dataLoad();
        })
        .catch((exception) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Ocorreu um erro ao excluir os dados!',
            text: 'Erro ao excluir o Pré - Pedido, por favor nos contate para corrigir-mos!'
          });
          console.log(exception)
        });
    },
    canSee(action) {
      return hasPermission(`${this.$route.name}-${action}`)
    },
    getType(data) {
      return (JSON.parse(data)).type;
    },
    closeExpand () {
      let $target = [];
      this.$refs.vsTrElement.forEach((element) => {
          if (element.expanded === true) { 
              $target.push(element)
          }
      })
      $target.forEach(element => element.$el.click())
    },
    checkId(currentRoute) {
      if (currentRoute === 'chat-attendance') {
        return "tableDataPreOrdersChat";
      }
    },
    bindStyle() {
      if (this.$route.name === 'chat-attendance') {
        return {
          marginBottom: '8px'
        }
      }
      return {
        marginBottom: '16px'
      }
    },
    showWithdrawal(address) {
      if (address) {
        const formatedAddress = JSON.parse(address);
        if (formatedAddress.address === 'none') {
            return false;
        }
      }
      return true;
    }
  },
  async mounted() {
    this.$store.dispatch('setShowLoadingOverlay', false)

    await this.dataLoad();
    this.isMounted = true;
  },
  watch: {
    'page'() {
      this.dataLoad()
    },
    'itemsPerPage'() {
      this.page = 1
      this.dataLoad()
    }
  },
}
</script>

<style lang="scss">
.order-infos-btn {
  .vs-button--text {
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
  }
}
#tableDataPreOrdersChat {
  .vs-con-tbody.vs-table--tbody {
      background-color: transparent !important;
      border: 0 !important; 
  }
  table.vs-table.vs-table--tbody-table {
      border-collapse: separate;
      border-spacing: 0 0.5rem;
      padding: 0 1rem;
  }
  header {
      margin-left: 16px;
      margin-right: 16px;
      div > input {
          border: solid 0.1px !important;
          color: #726f6fb4;
      }
  }
  tbody {  
      tr {
          td {
              padding: 0px;
              border-style: solid; 
              border-color: #b6bebd6e;
              padding-right: 6px;
              height: 4em;
          }
          td.td-check {
              display: flex;
          }
          td.td-check.active-expanded {
              display: flex;
              flex-direction: row;
              align-content: center;
              flex-wrap: wrap;
          }
          td:first-of-type {
              border-top-left-radius: 14px; 
              border-bottom-left-radius: 14px; 
              border-width: 1px 0px 1px 1px;
          }
          td:nth-of-type(2), td:nth-of-type(3), td:nth-of-type(4), td:nth-of-type(5) {
              border-width: 1px 0px 1px 0px; 
          }
          td:last-of-type {
              border-width: 1px 1px 1px 0px;
              border-top-right-radius: 14px;
              border-bottom-right-radius: 14px;
              padding-right: 10px;
          }
          td.ajuste-tamanho-vstd-preorders {
              padding-right: 10px;
              width: 160px;
              border-width: 1px 0px 1px 0px; 
              div {
                  float: right;
                  button {
                      display: flex;
                      border-radius: 15px;
                      height: 35px;
                      padding: 0px 16px 0px 25px;
                      justify-content: center;
                  }
                  span.vs-button-text.vs-button--text {
                      display: flex;
                      flex-direction: row;
                      justify-content: center;
                      align-items: center;
                  }
              }
          }
      }
  }
}
</style>

<style lang="scss" scoped>
.table-data-pre-orders-chat {
  .vs-con-tbody.vs-table--tbody {
    background-color: transparent !important;
    border: 0 !important;
  }
  table.vs-table.vs-table--tbody-table {
    border-collapse: separate;
    border-spacing: 0 0.5rem;
    padding: 0 1rem;
  }
  header {
    margin-left: 16px;
    margin-right: 16px;
    div > input {
      border: solid 0.1px !important;
      color: #726f6fb4;
    }
  }
  tbody {
    tr {
      td {
        padding: 0px;
        padding-right: 6px;
        height: 4em;
      }
      td.td-check {
        display: flex;
      }
      td.td-check.active-expanded {
        display: flex;
        flex-direction: row;
        align-content: center;
        flex-wrap: wrap;
      }
      td:nth-of-type(2), td:nth-of-type(3), td:nth-of-type(4), td:nth-of-type(5) {
        border-width: 1px 0px 1px 0px;
      }
      td:last-of-type {
        border-width: 1px 1px 1px 0px;
        border-top-right-radius: 14px;
        border-bottom-right-radius: 14px;
        padding-right: 10px;
      }
      td.ajuste-tamanho-vstd-preorders {
        padding-right: 10px;
        width: 12rem;
        border-width: 1px 0px 1px 0px;
        div {
          float: right;
          button {
            display: flex;
            border-radius: 15px;
            height: 35px;
            padding: 0px 16px 0px 25px!important;
            justify-content: center;
          }
          span.vs-button-text.vs-button--text {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
          }
        }
      }

      .order-infos-div {
        display: flex;
        div {
          border: solid 2px #abb3b257;
          border-radius: 14px;
          cursor: pointer;
          margin: 8px;
          margin-left: 0;
          width: 90px;
          height: 80px;
          display: flex;
          flex-direction: column;
          align-content: center;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;

          span {
            font-size: 10px;
            text-align: center;
          }
          img {
            width: 36px;
            height: 36px;
            border-radius: 40px;
          }
        }
      }
    }
  }
  .pix-resize {
    width: 60px !important;
    height: 23px !important;
  }
  .card-resize {
    border-radius: 0 !important;
    height: 35px !important;
    width: 50px !important;
  }
  .cash-resize {
    width: 40px !important;
    height: 30px !important;
  }
}
.button-rows {
  position: relative;
  height: 60%;
  transform: translateY(-1em);
  margin-left: 10px;
}
.fixed-div-bottom {
  position: absolute;
  bottom: 0;
}

.button-create-new-android{
  width: 126px;
  margin-top: 5px;
}

.button-create-new-ios{
  width: 140px;
  margin-top: 5px;
}

.button-create-new{
  width: 250px; 
  box-shadow: none !important;
}
</style>
